import React, { useState } from 'react';
import { Mail, AlertCircle, ArrowRight, Loader2 } from 'lucide-react';

export default function AuthForm({ auth }) {
  const [email, setEmail] = useState('');
  const [localError, setLocalError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError('');
    const cleanEmail = email.trim();

    if (!cleanEmail) {
      setLocalError('Vui lòng nhập địa chỉ email quản trị.');
      return;
    }

    if (cleanEmail.toLowerCase() !== 'ducnhan762013@gmail.com') {
      setLocalError('Từ chối truy cập: Email này không có quyền quản trị.');
      return;
    }

    setIsLoading(true);
    try {
      const res = await auth.login(cleanEmail);
      if (!res || !res.success) {
        setLocalError(res?.error || 'Đăng nhập không thành công');
      }
    } catch {
      setLocalError('Có lỗi xảy ra khi xác thực.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full select-none">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-xs font-bold text-amber-200 mb-1.5">
            Email quản trị viên
          </label>
          <div className="relative">
            <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-amber-200/60" />
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setLocalError('');
              }}
              placeholder="Nhập email quản trị viên..."
              autoFocus
              className="w-full bg-[#200407] border border-[#520B12] rounded-xl pl-9 pr-3 py-2.5 text-xs text-[#FFF5E6] placeholder-amber-200/40 focus:outline-none focus:border-[#F5A623] focus:ring-2 focus:ring-[#F5A623]/20 transition"
            />
          </div>
        </div>

        {localError && (
          <div className="p-3 rounded-xl bg-red-950/80 border border-red-700/60 flex items-center gap-2 text-xs text-red-200">
            <AlertCircle size={14} className="shrink-0 text-red-400" />
            <span>{localError}</span>
          </div>
        )}

        <div className="pt-2">
          <button
            type="submit"
            disabled={isLoading || !email.trim()}
            className="w-full py-2.5 bg-gradient-to-r from-[#F5A623] to-[#E58F10] text-[#240306] rounded-xl text-xs font-black flex items-center justify-center gap-1.5 shadow-md hover:brightness-110 active:scale-95 transition disabled:opacity-50"
          >
            {isLoading ? (
              <>
                <Loader2 size={14} className="animate-spin" />
                <span>Đang xác thực...</span>
              </>
            ) : (
              <>
                <span>Đăng nhập</span>
                <ArrowRight size={13} />
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
